import { User } from './appointment';
import { Product } from './product';

export interface PaymentTicketRequest {
  id: string;
  amount: number;
  method: PaymentMethod;
  bank: PaymentBank;
  paymentReference: string;
  /** Anticipo de Flowww que se consume con este pago ("Aplicar anticipo"). */
  flowwwAdvanceGID?: number;
}

/** Anticipo sin consumir del paciente en la clínica (GET Ticket/Advances). */
export interface PendingAdvance {
  advanceGID: number;
  /** Número del anticipo que ve la clínica en Flowww. */
  advanceID?: number;
  amount: number;
}
export interface ProductTicketRequest {
  id: string;
  price: string;
}

export interface PendingPayment {
  user: User;
  amount: number;
  referenceId: string;
  productPayment: {
    product: Product;
  }[];
}

export enum PaymentMethod {
  Cash,
  CreditCard,
  Financing,
  Others,
  Wallet,
  AdvancedPayment,
}

export enum PaymentBank {
  None,
  Alma,
  Pepper,
  Cash,
  Stripe,
  CreditCard,
  GooglePay,
  ApplePay,
  Paypal,
  Frakmenta,
  InstantCredit,
  Scalapay,
}

export interface PaymentInitResponse {
  id: string;
  url: string;
  referenceId: string;
  embeddedReference: string;
  /** Why the provider rejected the payment (wrong NIF, missing data...), in Spanish. Only on failures. */
  errorMessage?: string;
}

export const minimumAmounts: Record<PaymentBank, number> = {
  [PaymentBank.None]: 0,
  [PaymentBank.Alma]: 50,
  [PaymentBank.Pepper]: 50,
  [PaymentBank.Cash]: 0,
  [PaymentBank.Stripe]: 0,
  [PaymentBank.CreditCard]: 0,
  [PaymentBank.GooglePay]: 0,
  [PaymentBank.ApplePay]: 0,
  [PaymentBank.Paypal]: 0,
  [PaymentBank.Frakmenta]: 59,
  [PaymentBank.InstantCredit]: 200,
  [PaymentBank.Scalapay]: 5,
};

// 0 = sin límite máximo
export const maximumAmounts: Record<PaymentBank, number> = {
  [PaymentBank.None]: 0,
  [PaymentBank.Alma]: 2000,
  [PaymentBank.Pepper]: 2500,
  [PaymentBank.Cash]: 0,
  [PaymentBank.Stripe]: 0,
  [PaymentBank.CreditCard]: 0,
  [PaymentBank.GooglePay]: 0,
  [PaymentBank.ApplePay]: 0,
  [PaymentBank.Paypal]: 0,
  [PaymentBank.Frakmenta]: 2000,
  [PaymentBank.InstantCredit]: 0,
  [PaymentBank.Scalapay]: 1500,
};
